import { useEffect } from "react";

export default function useConfigForm({
    config,
    setConfig,
    state,
    setState,
    originalConfigRef,
    onSend
}) {

    const { jsonOutput } = state;

    // -------------------------------
    // DIRTY + JSON CHECK
    // -------------------------------
    useEffect(() => {
        const currentString = JSON.stringify(config, null, 2);
        const originalString = JSON.stringify(originalConfigRef.current, null, 2);

        setState(prev => ({
            ...prev,
            formDirty: currentString !== originalString,
            jsonNeedsUpdate: jsonOutput === '' || currentString !== jsonOutput
        }));
    }, [config, jsonOutput]);

    // -------------------------------
    // GENERAR JSON
    // -------------------------------
    const handleGenerateJson = () => {
        setState(prev => ({
            ...prev,
            jsonOutput: JSON.stringify(config, null, 2),
            jsonNeedsUpdate: false
        }));
    };

    // -------------------------------
    // ENVIAR
    // -------------------------------
    const handleSend = async () => {
        // //console.log("ENVIANDO CONFIG:", config);

        // originalConfigRef.current = JSON.parse(JSON.stringify(config));

        if (onSend) {
            await onSend();
        }

        // setState(prev => ({
        //     ...prev,
        //     formDirty: false,
        //     jsonNeedsUpdate: false,
        //     jsonOutput: JSON.stringify(config, null, 2),
        //     estado: "Enviado",
        //     color: "green"
        // }));
    };

    // -------------------------------
    // CANCELAR
    // -------------------------------
    const handleCancel = () => {
        if (!state.formDirty) return;

        const confirm = window.confirm("¿Descartar cambios?");
        if (!confirm) return;

        setConfig(JSON.parse(JSON.stringify(originalConfigRef.current)));

        setState(prev => ({
            ...prev,
            jsonOutput: '',
            jsonNeedsUpdate: true,
            formDirty: false,
            estado: "Cancelado",
            color: "orange"
        }));
    };

    return {
        handleGenerateJson,
        handleSend,
        handleCancel
    };
}
